import { createRouter, createWebHistory } from 'vue-router'

const base = process.env.VUE_APP_RELATIVE_PATH || '/'

const routes = [
  {
    path: '/:Token/DocumentId', 
    name: 'DocumentId',
    component: () => import('@/components/documents/DocumentId.vue'),
    meta: { public: true}, 
  },
  {
    path: '/:Token/DocumentFace', 
    name: 'DocumentFace',
    component: () => import('@/components/documents/DocumentFace.vue'),
    meta: { public: true }, 
  },
  {
    path: '/:Token/DocumentImages', 
    name: 'DocumentImages',
    component: () => import('@/components/documents/DocumentImages.vue'),
    meta: { public: true }, 
  },
  {
    path: '/:Token/DocumentConfirm', 
    name: 'DocumentConfirm',
    component: () => import('@/components/documents/DocumentConfirm.vue'),
    meta: { public: true }, 
  },
  {
    path: '/:Token/DocumentSuccess', 
    name: 'DocumentSuccess',
    component: () => import('@/components/documents/DocumentSuccess.vue'),
    meta: { public: true }, 
  },
  {
    path: '/Interceramic/:Token/Verificacion', 
    name: 'Interceramic - Verificación',
    component: () => import('@/components/interceramic/1-Verificacion.vue'),
    meta: { public: true, unbranded: true }, 
  },
  {
    path: '/Interceramic/Domicilio', 
    name: 'Interceramic - Comprobante Domicilio',
    component: () => import('@/components/interceramic/1.5-Domicilio.vue'),
    meta: { public: true, unbranded: true }, 
  },
  {
    path: '/Interceramic/Revision', 
    name: 'Interceramic - Revisión',
    component: () => import('@/components/interceramic/2-Revision.vue'),
    meta: { public: true, unbranded: true }, 
  },
  {
    path: '/Interceramic/FirmaTanda1', 
    name: 'Interceramic - Firma Tanda 1',
    component: () => import('@/components/interceramic/3-Firma.vue'),
    meta: { public: true, unbranded: true }, 
  },
  {
    path: '/Interceramic/Validaciones', 
    name: 'Interceramic - Validaciones',
    component: () => import('@/components/interceramic/4-Validaciones.vue'),
    meta: { public: true, unbranded: true }, 
  },
  {
    path: '/Interceramic/Ofertas', 
    name: 'Interceramic - Ofertas',
    component: () => import('@/components/interceramic/5-Ofertas.vue'),
    meta: { public: true, unbranded: true }, 
  },
  {
    path: '/Interceramic/Terminos', 
    name: 'Interceramic - Términos y Condiciones',
    component: () => import('@/components/interceramic/6-Terminos.vue'),
    meta: { public: true, unbranded: true }, 
  },
  {
    path: '/Interceramic/FirmaTanda2', 
    name: 'Interceramic - Firma Tanda 2',
    component: () => import('@/components/interceramic/7-Firma.vue'),
    meta: { public: true, unbranded: true }, 
  },
  {
    path: '/Interceramic/Resumen', 
    name: 'Interceramic - Resumen',
    component: () => import('@/components/interceramic/8-Resumen.vue'),
    meta: { public: true, unbranded: true }, 
  },
  {
    path: '/Interceramic/Invalido', 
    name: 'Interceramic - Inválido',
    component: () => import('@/components/interceramic/9-Invalido.vue'),
    meta: { public: true, unbranded: true }, 
  },
  {
    path: '/Interceramic/SinOfertas', 
    name: 'Interceramic - Sin Ofertas',
    component: () => import('@/components/interceramic/9-SinOfertas.vue'),
    meta: { public: true, unbranded: true }, 
  }
]
const router = createRouter({
  history: createWebHistory(base),
  routes
})
router.beforeEach((to, from, next) => {
  const isPublic = !!to.meta.public;
  const isLoggedIn = !!localStorage.getItem('accessToken');
  if (to.name == 'DocumentId') {
    sessionStorage.removeItem('nroTicket');
  }
  const nroTicket = sessionStorage.getItem('nroTicket');
  const tktCompleted = sessionStorage.getItem('tktCompleted');
  if (tktCompleted && nroTicket === tktCompleted) {
    if (to.name !== 'DocumentSuccess') {
      return next({
        name: 'DocumentSuccess',
        params: { Token: to.params.Token },
        replace: true
      });
    }
  }
  if (isPublic || isLoggedIn) return next();
  // si usás Login como componente embebido (sin ruta /login), simplemente dejá que App.vue muestre el login
  return next(); 
});

export { router, base }
